var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5C0 58.2107 16.7893 75 37.5 75Z",
    fill: "#E0F01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2648 54.4941V54.675L32.9439 54.6844V54.4941C36.7395 52.3508 39.3594 50.1672 41.7168 47.8859H52.5246L59.2648 54.4941ZM52.7434 20.2159L46.0715 13.6719H45.8777C45.8777 13.6719 45.9902 25.8677 34.7886 36.9595C23.8275 47.8152 10.9375 47.8398 10.9375 47.8398V48.0301L17.7342 54.6875C17.7342 54.6875 30.4366 54.8129 41.6574 43.807C52.8371 32.838 52.7434 20.2159 52.7434 20.2159Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider5);
export default __webpack_public_path__ + "static/media/slider-5.ed51c71bb6b4e6c43c4b7f10d728b2f5.svg";
export { ForwardRef as ReactComponent };